import { render, staticRenderFns } from "./AboutTeacher.vue?vue&type=template&id=f2515544&scoped=true&"
import script from "./AboutTeacher.vue?vue&type=script&lang=js&"
export * from "./AboutTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2515544",
  null
  
)

export default component.exports